export const configs = {
    urls: {
        pokeApi: 'https://pokeapi.co/api/v2',
    }
}